import { PAGE_TYPE } from '../../constants';
import { buildPagePerStoreBreadcrumbs } from '../../structured-data/build-pps-breadcrumbs';

/**
 * Generates the description for the Pro Desk detail page.
 *
 * @param {Object} params - Parameters for generating the description.
 * @param {string} params.storeName - The name of the store.
 * @returns {string} The generated description for the Pro Desk detail page.
 */
export const generateProDeskDesc = ({ storeName }) => {
  const storeTitle = storeName ? `${storeName} Home Depot` : 'Home Depot';
  return 'Get Pro benefits, services, bulk pricing, quick check out and more at '
  + `the ${storeTitle} Pro Desk. For Pros like you, near you.`;
};

/**
 * Generates an array of schema objects for use in generating Pro Desk structured data script tags.
 * If `emtSchema` is provided, it will be used as the only schema in the array.
 * Otherwise, a default breadcrumb schema is generated using the provided store information.
 *
 * @param {Object} params - Parameters for generating schemas.
 * @param {string} [params.emtSchema] - A string containing the JSON-LD schema content for the Pro Desk page.
 * @param {Object} params.storeInfo - The store information object.
 * @returns {Array} An array of schema objects, each with a `content` (string) and `id` (string).
 */
export const getProDeskSchemas = ({ emtSchema, storeInfo }) => {
  if (emtSchema) {
    return [{ content: emtSchema, id: 'proDeskStructuredData' }];
  }
  return [{
    content: buildPagePerStoreBreadcrumbs({
      storeInfo,
      departmentName: 'Pro Desk',
      departmentID: PAGE_TYPE.PRO_DESK
    }),
    id: 'proDeskStructuredBreadcrumb'
  }];
};